import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ breakpoints, shape }: Theme) => ({
  selectChevron: {
    display: 'none',
  },
  select: {
    width: '100%',
    '&:focus': {
      background: 'transparent',
    },
  },
  root: {
    fontSize: 14,
    '& $select': {
      paddingRight: 46,
    },
  },
  unselected: {
    '& $select': {
      opacity: 0.42,
    },
  },
  selectMenu: {
    padding: 5,
    boxShadow: '0 5px 20px 0 rgba(32, 49, 91, 0.2)',
  },
  menuListItem: {
    fontSize: 14,
    padding: 0,
    '& li': {
      borderRadius: shape.borderRadius,
      height: 'auto',
      lineHeight: '21px',
      fontSize: 14,
      padding: '5px 10px',
      [breakpoints.down(426)]: {
        marginBottom: 15,
      },
    },
  },
  adorendEnd: {
    paddingRight: 0,
  },
  placeholder: {
    opacity: 0.42,
    margin: 0,
  },
  readOnly: {
    pointerEvents: 'none',
  },
}));
